import { useState, useEffect } from 'react';
import { isAdminUser } from '../utils/maintenanceConfig';

/**
 * Hook to manage user role and admin privileges
 * Can be extended to integrate with authentication system
 */
export const useUserRole = () => {
  const [userRole, setUserRole] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate checking user authentication status
    // In a real application, this would integrate with your auth system
    // For example: Firebase Auth, JWT tokens, localStorage, etc.
    
    const checkUserRole = () => {
      try {
        // Example: Check localStorage for user role
        const storedUserRole = localStorage.getItem('userRole');
        
        // Example: Check for admin token in localStorage
        const adminToken = localStorage.getItem('adminToken');
        
        // Determine user role based on stored data
        if (adminToken || storedUserRole === 'admin') {
          setUserRole('admin');
        } else if (storedUserRole) {
          setUserRole(storedUserRole);
        } else {
          setUserRole(null);
        }
      } catch (error) {
        console.error('Error checking user role:', error);
        setUserRole(null);
      } finally {
        setIsLoading(false);
      }
    };

    checkUserRole();
  }, []);

  const isAdmin = isAdminUser(userRole);
  const canBypassMaintenance = isAdmin;

  return {
    userRole,
    isAdmin,
    canBypassMaintenance,
    isLoading,
    setUserRole
  };
};

export default useUserRole;
